import type { ReactNode } from 'react';
import BarChartIcon from '@mui/icons-material/BarChart';
import ApartmentIcon from '@mui/icons-material/Apartment';
import GroupIcon from '@mui/icons-material/Group';
import SyncIcon from '@mui/icons-material/Sync';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SavingsIcon from '@mui/icons-material/Savings';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import GavelIcon from '@mui/icons-material/Gavel';

export interface NavItem {
  label: string;
  path: string;
  icon: ReactNode;
}

export interface NavGroup {
  title: string;
  items: NavItem[];
}

/**
 * Menügruppen je Rolle: Auswertung und Budgetrücklage (D-22) für alle, Umsatzsteuer (D-21),
 * KSt-Erklärung (D-25) und Liquidität für Admin und Vorstand,
 * Stammdaten nur für den Admin (FR-4, FR-5).
 */
export function navGroups(isAdmin: boolean, seesAllDivisions = isAdmin): NavGroup[] {
  const groups: NavGroup[] = [
    {
      title: 'Auswertung',
      items: [
        { label: 'Dashboard', path: '/dashboard', icon: <BarChartIcon /> },
        { label: 'EÜR', path: '/euer', icon: <RequestQuoteIcon /> },
        { label: 'Budgetrücklage', path: '/budgetruecklage', icon: <SavingsIcon /> },
        ...(seesAllDivisions
          ? [
              { label: 'Umsatzsteuer', path: '/umsatzsteuer', icon: <ReceiptLongIcon /> },
              { label: 'KSt-Erklärung', path: '/kst', icon: <GavelIcon /> },
              { label: 'Liquidität', path: '/liquiditaet', icon: <AccountBalanceIcon /> },
            ]
          : []),
      ],
    },
  ];
  if (isAdmin) {
    groups.push({
      title: 'Stammdaten',
      items: [
        { label: 'Abteilungen', path: '/abteilungen', icon: <ApartmentIcon /> },
        { label: 'Benutzer', path: '/benutzer', icon: <GroupIcon /> },
      ],
    });
    groups.push({
      title: 'Daten',
      items: [
        { label: 'Zuordnungen', path: '/zuordnungen', icon: <AccountTreeIcon /> },
        { label: 'Import', path: '/import', icon: <SyncIcon /> },
      ],
    });
  }
  return groups;
}
